// Decorative falling sprinkles + drips overlay (CSS-only)
const SPRINKLE_COLORS = ["#E63946","#FFB5A7","#FFD166","#00B4D8","#C6FF00","#A5E3C7"];

export default function Sprinkles({ count = 14 }) {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 z-[1] overflow-hidden" data-testid="sprinkles-bg">
      {Array.from({ length: count }).map((_, i) => {
        const left = (i * 7.3 + 3) % 100;
        const delay = (i * 0.7) % 8;
        const duration = 7 + ((i * 1.3) % 6);
        const color = SPRINKLE_COLORS[i % SPRINKLE_COLORS.length];
        const size = 6 + (i % 4) * 2;
        return (
          <span
            key={i}
            className="absolute top-[-30px] block rounded-full opacity-30"
            style={{
              left: `${left}%`,
              width: `${size}px`,
              height: `${size * 2.2}px`,
              background: color,
              borderRadius: "999px",
              transform: `rotate(${(i * 37) % 180}deg)`,
              animation: `sprinkle-fall ${duration}s linear ${delay}s infinite`,
            }}
          />
        );
      })}
    </div>
  );
}

